module.exports = __webpack_public_path__ + "static/media/mandai.f3e7e414.png";